<script>

import { useToast } from "vue-toastification";

import LoadingScreen from '@/components/General/LoadingScreen'
import LoadingButton from '@/components/General/LoadingButton'
import Alert from '@/components/General/Alert'

//general functions
import MixinGeneralFunct from '@/mixins/GeneralFunctions';
import { defineComponent } from 'vue'

//data
import { getGroupsToLevel, unlockLevel, saveGroupsToLevel } from '@/services/serviceLevel';

export default defineComponent ({
	setup() {
		const toast = useToast();
		return { toast }
	},
	name: 'LevelGroups',
	mixins: [ MixinGeneralFunct ],
	components: {
		LoadingScreen
		,LoadingButton
		,Alert
	},
	props: {'levelId': String, 'auth':Object, 'secData':Object, 'modalObject': Object, 'modalId': String},
	emits: ["levelId","changeRecord"],
	data() {
		return {
			metaData: [],
			
			isLoading:true,
			isSending:false,
			
			basicData:[],
			
			groups:[]
			
		}
	},
	
	mounted:function(){
		
	},
	
	methods: {
		// load data form
		loadDefaultValues:function(){
			
			this.isLoading=true

			getGroupsToLevel({levelId:this.levelId}).then(response => {
				if(!response.statusText){
					this.isLoading=false
					this.metaData = response.metaData;
					this.groups = response.groups;
					this.basicData = response.basicData;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});
			
		},
		
				
		onSave:function(){
			
			this.isSending=true

			saveGroupsToLevel({groups:this.groups,levelId:this.levelId}).then(response => {
				if(!response.statusText){
					this.isSending=false
					if(response.resCode==1){
						this.toast.success(this.$t('msgCore.dataWasSaved'));
						this.$emit('changeRecord', '')
						this.groups = [];
						this.modalObject.hide();
					}else if(response.resCode==0){
						this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
					}else if(response.resCode==2){
						this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
					}else if(response.resCode==3){
						this.toast.error(this.$t('msgCore.accessDenied'));
					}
				}else{
					this.isSending=false
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});
		},
		
		onClose:function(){
			if(this.levelId!='null'){
				unlockLevel({levelId:this.levelId}).then(response => {
					if(!response.statusText){
						this.isLoading=false
						if(response.resCode==1){
							this.$emit('changeRecord', '')
							this.modalObject.hide();
						}
					}else{
						this.isLoading=false
						this.toast.error(`${response.statusText} ${response.status}`);
					}
				});
			}else{
				this.$emit('changeRecord', '')
				this.modalObject.hide();
			}
		},
		
		
	},
	
	watch: {
		levelId() {
			this.loadDefaultValues();
		}
	},

	computed:{
		
	},
	
})

</script>

<template>
	<div>
	
		<div class="modal fade" :id="modalId" tabindex="-1" >
			<div class="modal-dialog modal-lg">
				<LoadingScreen :isLoading="isLoading"></LoadingScreen>
			<div class="modal-content">
				<div class="modal-header">
					<h6 class="modal-title">{{ $t('msgCore.AccessLevel') }} - {{ basicData.title }}</h6>
					
					
				</div>
		
						<div v-if="metaData.modulAccess && (auth.levelsChangeGroups)" class="modal-body">
								
							<div class="row">
								<div class="col-12">
									<p><b>{{$t('msgCore.accessGroups')}}</b></p>
								</div>	
							</div>	
							
							
							<div class="row">
								
								<div class="col-12" >
								
									<div  v-for="(group) in groups" :key="group" class="togglebutton">
										<label>
											<input v-model='group.isSelected' type="checkbox">
											<span class="toggle"></span>
											{{group.title}}
										</label>
									</div>
								
								</div>
								
							</div>
							
						
						</div>
						
						<div v-else class="modal-body">
							<div class="row">
								<div class="col-12 mt-3">
									<Alert type="warning" :label="$t('msgCore.accessDenied')" />
								</div>
							</div>
						</div>
						
						
						
						
						<div class="modal-footer">
						
							<div class="btn-group">
								<button type="button" v-on:click="onClose()" class="btn btn-default btn-sm">{{ $t('msgCore.btnClose') }}</button>
								
								
								<LoadingButton :isDisabled="(!auth.levelsChangeGroups || isSending || !metaData.modulAccess)" :isSending="isSending" @onClick="onSave" :label="'msgCore.btnSave'" color="warning"></LoadingButton>
							</div>	
							
						</div>
					
			
				
				
			
			</div>

		</div>
		
	</div>
		
</div>	
</template>


